import React from 'react';
import { MessageCircle } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="bg-[#f8f9fb] pt-20 pb-32 px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <img src="/assets/logo.png" alt="Dr. Alvará" className="h-24 md:h-40 w-auto mx-auto mb-10" />
        <h1 className="text-4xl md:text-6xl font-serif font-bold text-brand-dark mb-6 leading-tight">
          Gestão que protege <br />
          <span className="text-brand-blue italic">sua operação</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-500 mb-10 max-w-2xl mx-auto leading-relaxed">
          A Dr. Alvará cuida da regularização da sua empresa para que você foque no que realmente importa: o seu negócio. <br /><br />
          Somos especialistas em alvarás, licenças e segurança documental contínua, garantindo que seu negócio opere com tranquilidade.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="https://wa.me/5519989038450" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-brand-dark text-white px-8 py-4 rounded-md font-medium hover:bg-opacity-90 transition-all w-full sm:w-auto justify-center">
            <MessageCircle size={20} />
            Fale pelo WhatsApp
          </a>
          <a href="#servicos" className="bg-white text-brand-dark border border-gray-200 px-8 py-4 rounded-md font-medium hover:bg-gray-50 transition-all w-full sm:w-auto justify-center inline-flex items-center">
            Conheça nossos serviços
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
